/* eslint-disable */
import * as React from 'react';
const SvgDeleteV1Icon = (props) => (React.createElement("svg", { viewBox: "0 0 8.1 8.1", width: "1em", height: "1em", ...props },
    React.createElement("path", { d: "M8.1.8L4.9 4.1l3.3 3.3-.9.7-3.2-3.2L.8 8.1 0 7.3 3.3 4 0 .8.8 0l3.3 3.3L7.3 0z" })));
export default SvgDeleteV1Icon;
/* eslint-enable */
